import React from 'react'
import { useTranslation } from 'react-i18next'
import { getAppointmentDateAndTimeStrings } from '@components/TreatmentInfo/TreatmentInfo.helpers'
import { useDateFnsLocale } from '@hooks/useDateFnsLocale'
import { useGetTreatmentInfo } from '@hooks/useGetTreatmentInfo'
import { useLanguage } from '@hooks/useLanguage'
import useStyles from './styles'

export const SelectedSlotInfo = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const language = useLanguage()
  const { selectedAppointment } = useGetTreatmentInfo()
  const locale = useDateFnsLocale()
  const [appointmentDate, appointmentTime] = getAppointmentDateAndTimeStrings(
    selectedAppointment,
    language,
    locale,
    false
  )

  return (
    <div className={classes.selectedAppointmentInfo}>
      {t('selected_appointment_slot')} {appointmentDate}, {appointmentTime}
    </div>
  )
}
